import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { RedeemComponent } from 'src/app/purchase/redeem/redeem.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';

import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-confirmations-modal',
    templateUrl: './confirmations-modal.component.html',
    styleUrls: ['./confirmations-modal.component.scss'],
    standalone: true,
    imports: [MatIconModule, MatDialogModule, MatButtonModule, TranslateModule]
})
export class ConfirmationsModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title: string; subtitle: string; type: string; seeMyPoints: boolean },
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ConfirmationsModalComponent>
  ) { }

  public openRedeemModal(): void {
    this.dialogRef.close();
    this.dialog.open(RedeemComponent, { data: { hideButton: false } });
  }
}
